import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getSampleDataSourcePreference,
  subscribeSampleDataSourcePreference,
} from '../services/systems/sample-local/sampleLocalMode';

/**
 * Excel 入出力などクラウド DB 専用画面用。
 * ローカル Zip 正本のときは一覧へ戻す（排他）。
 * 帳票（/reports）は Local 対応済みのため本フックを使わない。
 */
export function useRedirectIfSampleLocalPreferred(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const check = () => {
      if (getSampleDataSourcePreference() === 'local') {
        navigate('/samples', { replace: true });
      }
    };
    check();
    return subscribeSampleDataSourcePreference(check);
  }, [navigate]);
}
